import IconBase from "../IconBase";

const PinterestIcon = (props) => {
  return (
    <IconBase {...props}>
      <path
        d="M12.51 1.5C8.18999 1.5 3.92999 4.38 3.92999 9.03C3.92999 11.985 5.59499 13.68 6.59999 13.68C7.01999 13.68 7.25999 12.525 7.25999 12.195C7.25999 11.805 6.26999 10.965 6.26999 9.345C6.26999 5.955 8.84999 3.57 12.18 3.57C15.045 3.57 17.16 5.205 17.16 8.19C17.16 10.425 16.26 14.61 13.365 14.61C12.315 14.61 11.415 13.86 11.415 12.765C11.415 11.175 12.525 9.63 12.525 7.995C12.525 5.205 8.57999 5.715 8.57999 9.075C8.57999 9.78 8.66999 10.56 8.98499 11.205C8.39999 13.71 7.21499 17.43 7.21499 20.01C7.21499 20.805 7.33499 21.585 7.40999 22.38C7.55999 22.545 7.48499 22.53 7.69499 22.44C9.80999 19.53 9.73499 18.975 10.695 15.165C11.22 16.155 12.555 16.68 13.605 16.68C18.075 16.68 20.085 12.33 20.085 8.4C20.085 4.215 16.47 1.5 12.51 1.5Z"
        fill="currentColor"
      />
    </IconBase>
  );
};

export default PinterestIcon;
